import React from 'react';
import Img from '../images/testimony1.png';
import Img_people from '../images/people.jpg';
import Img_arch from '../images/architect.jpg';
import Img_offer from '../images/fp-post.jpeg';

export default () => (

	<div className='aboutpage-CN'>
		<h1>About New Wave Property Group</h1>
		<div class='aboutpage-img-div'>
			<img src={Img_people} class="about_page_img1"></img>
			<div className='abt-back'>
				<h4>
					WE ARE COMMUNITY BUILDERS
				</h4>
				<p>
					New Wave Property Group (NWPG) is a property development, project management and property management firm turning empty infill lots into multi-unit rental apartments. Our focus is small to mid-scale buildings that sit comfortably inside existing neighbourhoods… the kind of housing that quietly adds density without killing character. From the first sketch to the final inspection, we coordinate the full journey so landowners, capital holders, and future residents all benefit from thoughtful, long-term housing solutions.
				</p>
			</div>
		</div>
		<br></br>
		<div class='aboutpage-img-div'>
			<div className='abt-back-2'>
				<h4>
					WHAT WE OFFER
				</h4>
				<h2>We Build for People </h2>
				<p>
					Our work starts with the vacant infill lot… site review, zoning analysis, and understanding what the land can actually support within city bylaws, sometimes requiring variances requested at a Committee of Adjustment (COA) public hearing. From there, we lead design, planning approvals, and construction to deliver durable, efficient rental units on infill land… in some cases adding a new multi-unit building behind or beside an existing dwelling that stays, in others completing a full ground-up build on the perfect empty lot.
				</p>
				<p>	Every project is built for real people… layouts that make sense, materials that last, and operations that work in the real world, not just in a spreadsheet.</p>
			</div>
			<img src={Img_offer} class="about_page_img_offer"></img>
		</div>
		<br></br>

		<div class='aboutpage-img-div'>
			<img src={Img_arch} class="about_page_img1"></img>
			<div className='abt-back-2'>
				<h4>
					WHY WORK WITH US
				</h4>
				<p>Partnering with NWPG means you’re not guessing your way through development. You’re working with a team that lives in the details… zoning, numbers, timelines, and everything in between. We support landowners who don’t know where to start, capital holders who want to build rentals without becoming full-time developers, and communities that need well-designed multi-unit housing.</p>
				<p>
					We care about three things above all… good housing, honest numbers, and projects that actually get finished.
				</p>
				<p>
					When needed, we connect you with trusted realtors, mortgage brokers, and lenders we’ve worked with before… and we outsource architects, engineers, and contractors to partners we already have strong working relationships with, so every stage of the project is handled by the right specialist.
				</p>
			</div>
		</div>
		<br></br>


		<div className="team">
			<h4 className="team-title">Our Team</h4>
			<hr className="underline"></hr>
			<div className="aboutpage-split-1">
				<div className="aboutpage-text">
					<h4 class="title">Strategic Partner</h4>
					<h4 class="name">Frankie Geddes</h4>
					<p>
						As the operational heartbeat of our property development firm, Frankie Geddes brings a unique fusion of emotional intelligence and personal magnetism to the table. Tasked with driving the company's operations, he employs precise planning and execution to meet our goals. With an ardor for orchestrating large-scale projects, Frankie is the navigational force directing our team's course in property development.
					</p>
				</div>
			</div>

			<div className="aboutpage-split-2">

				<div className="aboutpage-text">
					<h4 class="title">Strategic Partner</h4>
					<h4 class="name">Najman Mughal</h4>
					<p>
						Najman Mughal brings over a decade of valuable experience to the construction industry, successfully navigating the complexities of city permitting processes and collaborating with contractors to ensure efficient project completion. His expertise lies in streamlining construction projects and facilitating effective communication between stakeholders, contributing to the successful execution of various ventures.						</p>
				</div>
			</div>
		</div>
	</div>

);
